<template>
	<div class="protocol-page" v-html="html"></div>
</template>

<script setup>
	import {  onMounted } from "vue";
	/* eslint-disable no-mixed-spaces-and-tabs */

	import { onBeforeMount, ref } from 'vue';
	import { useRoute } from 'vue-router';
	import apiOther from '@/api/modules/api-other';
	const html = ref('');
	const route = useRoute();
	onMounted(() => {

		if(route.params.code.indexOf('third_SDK') > -1) {
			const host = location.protocol + '//' + location.host
      		const hostAgree = `${host}/sunline/agreement-benben/agreement_4_en.html`
			location.href = hostAgree
		}
	});
	onBeforeMount(async () => {
		const { content = '', title = '' } = await apiOther.getProtocol(route.params.code);
		document.title = title;
		html.value = content;
	});
</script>

<style lang="stylus">
	.protocol-page {
	  box-sizing: border-box;
	  padding: 20px 25px 20px;
	  background-color: #fff;
	  width: 100%;
	  height:100%;
	  overflow: auto;
	  font-size: 28px;
	  p {
	    line-height: 1.6;
	    color: #000;
	    word-wrap: break-word;
	    word-break: normal;
	    img {
	      max-width: 100%;
	    }
	  }
	}
</style>
